/*global site_info */

import AjaxFeed from 'wp-ajax-feed';

export default {
    toggle: $('.resource-tab .resource-tab-title'),
    content: $('.resource-tab-content'),
    init: function () {
        this.form = $('#resource-feed-filter');
        if (this.form.length < 1) return;
        this.isInitalFeed = true;
        this.bindEvents();
        this.buildFeed();
    },

    buildFeed: function () {
        AjaxFeed.init({
            'baseUrl': site_info.ajax_url,
            'action': 'get_resource_feed',
            'container': $('#resource-posts-wrapper'),
            'filterForms': this.form,
            'paginationContainer': $('#resource-pagination-wrapper'),
            'paginationDataAttribute': 'data-ajax-page',
            'submitOnFilterUpdate': true,
        });
    },

    toggleActive: function ($$) {
        let parent = $$.parent('.resource-tab'),
            content = parent.find('.resource-tab-content');

        if (parent.hasClass('open')) {
            parent.removeClass('open');
            content.slideUp();
        } else {
            $('.single-tab').removeClass('open');
            parent.addClass('open');
            $('.tab-content').slideUp();
            content.slideDown();
        }
    },


    bindEvents: function () {
        let _this = this;
        $(window).on('ajax-feed/afterFeedUpdate', () => {
            if (this.isInitalFeed) {
                this.isInitalFeed = false;
                return;
            }
            if (!this.isInitalFeed) {
                $('.resource-feed-pagination').removeClass('loading-more-posts');
            }
        });
        $(window).on('ajax-feed/beforeFeedUpdate', () => {
            if (this.isInitalFeed) return;
            $('.resource-feed-pagination').addClass('loading-more-posts');
            $('html, body').animate({
                scrollTop: $('#resource-posts-wrapper').offset().top - 100,
            }, 1000, function () {
            });
        });

        this.toggle.click(function () {
            _this.toggleActive($(this));
        });


    },
};
